var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoneIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.083 2.333v9.334h5.834V2.333zM3.5 1.167h7c.322 0 .583.26.583.583v10.5a.583.583 0 0 1-.583.583h-7a.583.583 0 0 1-.583-.583V1.75c0-.322.26-.583.583-.583M7 9.917a.583.583 0 1 1 0 1.166.583.583 0 0 1 0-1.166"
})));
export { SvgPhoneIcon as ReactComponent };
export default __webpack_public_path__ + "49ec3f399f3e4330a33ce24e509ef384.svg";